import Echo from 'laravel-echo';
import Pusher from 'pusher-js';

let echoInstance = null;

export const getEcho = () => {
  const key = process.env.REACT_APP_PUSHER_APP_KEY;
  const cluster = process.env.REACT_APP_PUSHER_APP_CLUSTER;

  if (!key || !cluster) {
    return null;
  }

  const token = localStorage.getItem('token');

  if (!token) {
    return null;
  }

  if (echoInstance) {
    echoInstance.connector.options.auth.headers.Authorization = `Bearer ${token}`;
    return echoInstance;
  }

  window.Pusher = Pusher;

  echoInstance = new Echo({
    broadcaster: 'pusher',
    key,
    cluster,
    forceTLS: true,
    authEndpoint: `${process.env.REACT_APP_API_URL}/client-portal/broadcasting/auth`,
    auth: {
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: 'application/json',
      },
    },
  });

  return echoInstance;
};

export const disconnectEcho = () => {
  if (echoInstance) {
    echoInstance.disconnect();
    echoInstance = null;
  }
};
